import React, { useState } from 'react';
import DateInput from './DateInput';

// (임시 CSS)
const modalStyles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  },
  modal: {
    background: 'white', padding: '25px', borderRadius: '8px',
    width: '90%', maxWidth: '500px', zIndex: 1001,
    maxHeight: '80vh', overflowY: 'auto'
  },
  title: { marginTop: 0 },
  formGroup: { marginBottom: '15px' },
  label: { display: 'block', marginBottom: '5px', fontWeight: 'bold' },
  input: { width: '100%', padding: '8px', boxSizing: 'border-box' },
  buttonContainer: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' },
  saveButton: { padding: '8px 15px', background: '#28a745', color: 'white', border: 'none', borderRadius: '4px' },
  cancelButton: { padding: '8px 15px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px' }
};

const BatchParticipantModal = ({ isOpen, onClose, onSave, projects }) => {
  // ⬇️ 'registrar' 필드 포함
  const [formData, setFormData] = useState({
    memo: '',
    projectId: '',
    startDate: '',
    endDate: '',
    registrar: '',
    bankName: '',
    bankAccount: '',
    workplace: '',
    district: '',
    address: ''
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    // ⬇️ 빈 값을 제외하고 'registrar'를 포함
    const dataToUpdate = {};
    if (formData.memo) { dataToUpdate.memo = formData.memo; }
    if (formData.projectId) { dataToUpdate.projectId = parseInt(formData.projectId, 10); }
    if (formData.startDate) { dataToUpdate.startDate = formData.startDate; }
    if (formData.endDate) { dataToUpdate.endDate = formData.endDate; }
    if (formData.registrar) { dataToUpdate.registrar = formData.registrar; }
    if (formData.bankName) { dataToUpdate.bankName = formData.bankName; }
    if (formData.bankAccount) { dataToUpdate.bankAccount = formData.bankAccount; }
    if (formData.workplace) { dataToUpdate.workplace = formData.workplace; }
    if (formData.district) { dataToUpdate.district = formData.district; }
    if (formData.address) { dataToUpdate.address = formData.address; }
    
    if (Object.keys(dataToUpdate).length === 0) {
      alert('일괄 수정할 값을 하나 이상 입력하세요.');
      return;
    }
    onSave(dataToUpdate);
    setFormData({ memo: '', projectId: '', startDate: '', endDate: '', registrar: '', bankName: '', bankAccount: '', workplace: '', district: '', address: '' });
    onClose();
  };

  const handleClose = () => {
    setFormData({ memo: '', projectId: '', startDate: '', endDate: '', registrar: '', bankName: '', bankAccount: '', workplace: '', district: '', address: '' });
    onClose();
  };

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal}>
        <h3 style={modalStyles.title}>선택 항목 일괄 변경</h3>
        <p>선택된 모든 참여자의 정보를 일괄 변경합니다. (빈 칸은 무시됩니다)</p>

        <div style={modalStyles.formGroup}>
          {/* ⬇️ [연쇄 수정] '사업 유형' -> '사업명' */}
          <label style={modalStyles.label}>사업명</label>
          <select name="projectId" style={modalStyles.input} value={formData.projectId} onChange={handleChange}>
            <option value="">-- 변경 안함 --</option>
            {projects.map(p => (
              // ⬇️ [연쇄 수정] p.businessType -> p.projectName
              <option key={p.id} value={p.id}>{p.projectName}</option>
            ))}
          </select>
        </div>
        
        <div style={modalStyles.formGroup}>
          {/* ⬇️ [연쇄 수정] '사업명' -> '메모' */}
          <label style={modalStyles.label}>메모</label>
          <input type="text" name="memo" style={modalStyles.input} value={formData.memo} onChange={handleChange} placeholder="입력 시 일괄 변경됨" />
        </div>
        <div style={modalStyles.formGroup}>
          <label style={modalStyles.label}>은행</label>
          <input type="text" name="bankName" style={modalStyles.input} value={formData.bankName} onChange={handleChange} placeholder="입력 시 일괄 변경됨" />
        </div>

        <div style={modalStyles.formGroup}>
          <label style={modalStyles.label}>계좌번호</label>
          <input type="text" name="bankAccount" style={modalStyles.input} value={formData.bankAccount} onChange={handleChange} placeholder="입력 시 일괄 변경됨" />
        </div>
        <div style={modalStyles.formGroup}>
          <label style={modalStyles.label}>근무장소</label>
          <input type="text" name="workplace" style={modalStyles.input} value={formData.workplace} onChange={handleChange} placeholder="입력 시 일괄 변경됨" />
        </div>
        <div style={modalStyles.formGroup}>
          <label style={modalStyles.label}>읍면동</label>
          <input type="text" name="district" style={modalStyles.input} value={formData.district} onChange={handleChange} placeholder="입력 시 일괄 변경됨" />
        </div>
        <div style={modalStyles.formGroup}>
          <label style={modalStyles.label}>주소</label>
          <input type="text" name="address" style={modalStyles.input} value={formData.address} onChange={handleChange} placeholder="입력 시 일괄 변경됨" />
        </div>
        <div style={modalStyles.formGroup}>
          <label style={modalStyles.label}>참여시작일</label>
          <DateInput value={formData.startDate} onChange={(v) => setFormData(prev => ({ ...prev, startDate: v }))} inputStyle={modalStyles.input} />
        </div>

        <div style={modalStyles.formGroup}>
          <label style={modalStyles.label}>참여종료일</label>
          <DateInput value={formData.endDate} onChange={(v) => setFormData(prev => ({ ...prev, endDate: v }))} inputStyle={modalStyles.input} />
        </div>

        <div style={modalStyles.formGroup}>
          <label style={modalStyles.label}>담당자</label>
          <input type="text" name="registrar" style={modalStyles.input} value={formData.registrar} onChange={handleChange} placeholder="입력 시 일괄 변경됨" />
        </div>

        <div style={modalStyles.buttonContainer}>
          <button style={modalStyles.cancelButton} onClick={handleClose}>취소</button>
          <button style={modalStyles.saveButton} onClick={handleSave}>일괄 저장</button>
        </div>
      </div>
    </div>
  );
};

export default BatchParticipantModal;